import { faBox, faBoxesPacking, faGlobe, faListCheck, faUserPen, faUsers } from '@fortawesome/pro-regular-svg-icons';
import { externalLinks } from 'src/externalLinks';
import { Trainer } from 'src/models/trainer/trainer';

export interface ItemType {
  label: string;
  pluralLabel: string;
  value: string;
  modelName: string;
  icon: any;
  manageLink?: string;
  supportsQuantity: boolean;
  hide?: (trainer?: Trainer) => boolean;
}

export const selectableItemTypes: ItemType[] = [
  {
    label: 'Package',
    pluralLabel: 'Packages',
    value: 'package',
    modelName: 'Fbm::Package',
    icon: faBox,
    manageLink: externalLinks.managePackages(),
    supportsQuantity: false,
  },
  {
    label: 'Group',
    pluralLabel: 'Groups',
    value: 'group',
    modelName: 'Group',
    icon: faUsers,
    manageLink: '/groups',
    supportsQuantity: false,
    hide: (trainer?: Trainer) => !!trainer,
  },
  {
    label: 'Plan',
    pluralLabel: 'Plans',
    value: 'plan',
    modelName: 'WorkoutPlan',
    icon: faListCheck,
    manageLink: '/workout-plans',
    supportsQuantity: false,
    hide: (trainer?: Trainer) => !!trainer,
  },
  {
    label: 'Product',
    pluralLabel: 'Products',
    value: 'product',
    modelName: 'Exercisecom::Product',
    icon: faBoxesPacking,
    manageLink: '/products',
    supportsQuantity: true,
  },
  {
    label: 'Product Variant',
    pluralLabel: 'Product Variants',
    value: 'productVariant',
    modelName: 'ProductVariant',
    icon: faBoxesPacking,
    manageLink: '/products',
    supportsQuantity: true,
    hide: () => true,
  },
  {
    label: 'Online Training',
    pluralLabel: 'Online Training',
    value: 'onlineTraining',
    modelName: 'onlineTraining',
    icon: faGlobe,
    manageLink: externalLinks.customizePlatformClientSettings(),
    supportsQuantity: false,
    hide: (trainer?: Trainer) => !!trainer,
  },
  {
    label: 'Staff Subscription',
    pluralLabel: 'Staff Subscription',
    value: 'staffSubscription',
    modelName: 'StaffSubscription',
    icon: faUserPen,
    manageLink: undefined,
    supportsQuantity: false,
    hide: (trainer?: Trainer) => !trainer,
  },
];

/**
 * Get the display label for an itemType modelName
 * Maps model names like "Fbm::Package" to display names like "Package"
 */
export const getItemTypeLabel = (modelName: string): string => {
  const itemType = selectableItemTypes.find((t) => t.modelName === modelName);
  return itemType?.label || modelName;
};
